export default "__VITE_ASSET__DGXlC_VV__"